<template>
    <div class="app-modal-wrap" v-if="isShow">
        <div class="app-modal">
            <div class="content">{{text}}</div>
            <div class="btn-group">
                <div class="btn" v-if="showCancel" @click="bottonClick('cancel')" :style="{color: cancelColor}">{{cancelText}}</div>
                <div class="btn" @click="bottonClick('confirm')" :style="{color: confirmColor}">{{confirmText}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            bottonClick(type){
                this.isShow = false;
                this.onHide({type: type})
            }
        },
    }
</script>

<style scoped lang="scss">
    .app-modal-wrap{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .8);
        z-index: 999999999;
        .app-modal{
            width: 6rem;
            background: #fff;
            border-radius: 0.12rem;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .content{
                padding: 0.5rem;
                font-size: 0.3rem;
                text-align: center;
                color: #909090;
            }
            .btn-group{
                display: flex;
                border-top: 1px solid #ccc;
                .btn{
                    flex: 1;
                    height: 0.8rem;
                    border-right: 1px solid #ccc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #323232;
                    &:last-child{
                        border-right: 0;
                    }
                }
            }
        }
    }
</style>